import { render, staticRenderFns } from "./ImagePolaroid.vue?vue&type=template&id=1efa7baa&"
import script from "./ImagePolaroid.vue?vue&type=script&lang=js&"
export * from "./ImagePolaroid.vue?vue&type=script&lang=js&"
import style0 from "./ImagePolaroid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports